import React from "react";
import { Modal } from "antd";
import JobCardSections from "./index";

const JobCardSectionsModal = ({
  open,
  onCancel,
  jobCard,
  currentUser,
  onAssignMechanic,
  onOpenClaimIntimation,
  onOpenEstimate,
  onOpenSparesOrder,
  onStartWork,
  onWorkStatusChange,
}) => {
  return (
    <Modal
      title="JobCard Section Tracker"
      visible={open}
      onCancel={onCancel}
      footer={null}
      width={720}
      destroyOnClose
    >
      <JobCardSections
        jobCard={jobCard}
        currentUser={currentUser}
        onAssignMechanic={onAssignMechanic}
        onOpenClaimIntimation={onOpenClaimIntimation}
        onOpenEstimate={onOpenEstimate}
        onOpenSparesOrder={onOpenSparesOrder}
        onStartWork={onStartWork}
        onWorkStatusChange={onWorkStatusChange}
      />
    </Modal>
  );
};

export default JobCardSectionsModal;
